import { render, staticRenderFns } from "./bindaltOrg.vue?vue&type=template&id=1ba3a385&scoped=true"
import script from "./bindaltOrg.vue?vue&type=script&lang=js"
export * from "./bindaltOrg.vue?vue&type=script&lang=js"
import style0 from "./bindaltOrg.vue?vue&type=style&index=0&id=1ba3a385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3a385",
  null
  
)

export default component.exports